import { InjectionToken } from '@angular/core';
import { CoreAuthConfig } from './core-auth.models';

export const CORE_AUTH_CONFIG = new InjectionToken<CoreAuthConfig>('CORE_AUTH_CONFIG');
